import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Qué es StingFit exactamente?',
    a: 'StingFit es un parche transdérmico innovador que utiliza micro-dosis de veneno de abeja y extractos naturales para activar el metabolismo local, promover la quema de grasa abdominal, estimular la circulación y apoyar el drenaje linfático en la zona abdominal.'
  }, {
    q: '¿Cuándo veré resultados?',
    a: 'Muchas usuarias reportan una sensación de ligereza en los primeros 3-5 días. Los cambios visuales (reducción de hinchazón y grasa) suelen notarse a partir de la segunda o tercera semana de uso constante.'
  }, {
    q: '¿Cómo se usa el parche?',
    a: 'Es muy sencillo. Aplica un parche sobre la piel limpia y seca en la zona abdominal (preferiblemente cerca del ombligo) antes de dormir. Déjalo actuar durante 8 horas y retíralo por la mañana.'
  }, {
    q: '¿Es seguro el veneno de abeja?',
    a: 'Sí, utilizamos una forma procesada y segura de veneno de abeja en concentraciones diseñadas para uso tópico. Sin embargo, si eres alérgica a las picaduras de abeja, consulta con tu médico antes de usarlo.'
  }, {
    q: '¿Puedo usarlo si tengo alergias?',
    a: 'Si tienes alergia conocida a las picaduras de abeja o productos apícolas, te recomendamos consultar con tu médico antes de usar StingFit. Para otras alergias, el parche es generalmente seguro.'
  }, {
    q: '¿Cuánto tiempo dura cada parche?',
    a: 'Cada parche está diseñado para liberar sus ingredientes activos durante un periodo de 8 a 12 horas. Se recomienda usar uno nuevo cada noche.'
  }, {
    q: '¿Funciona para hombres y mujeres?',
    a: 'Sí, aunque nuestra fórmula es especialmente popular entre mujeres mayores de 50 años por su enfoque en la grasa visceral resistente y la retención de líquidos, es efectiva para ambos sexos.'
  }, {
    q: '¿Qué pasa si no funciona para mí?',
    a: 'Ofrecemos una garantía de satisfacción de 90 días. Si no estás contenta con los resultados, simplemente contáctanos y te devolveremos el dinero. Queremos que tu compra sea libre de riesgos.'
  }, {
    q: '¿Cuánto tarda el envío a España?',
    a: 'Los pedidos se procesan en 24 horas. El envío estándar a la península suele tardar entre 1 y 7 dias laborables.'
  }];
  return <Section background="cream" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-79">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-80">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100" data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-82">
                <span className="font-bold text-gray-900 text-lg" data-id="element-83">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="w-5 h-5 text-[#D4AF37]" data-id="element-84" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-85" />}
              </button>
              <AnimatePresence data-id="element-86">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-87">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-88">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}